import { ITRequisitionPaths } from './ITRequisitionPaths';
import { LeaveRequestPaths } from './LeaveRequestPaths';
import { PassportRequestPaths } from './PassportRequestPaths';
import { SalaryCertificatePaths } from './SalaryCertificatePaths';
import { OverseasMissionPaths } from './OverseasMissionPaths';
import { ResumptionRequestsPaths } from './ResumptionRequestsPaths';
import { AttendanceRequestPaths } from './AttendanceRequestPaths';
import { ResignationRequestsPaths } from './ResignationRequestsPaths';

export const ManageRequestPath = {
  MANAGE_REQUESTS: 'manage-requests',
};

export const ManageRequestsPaths = {
  ...ITRequisitionPaths,
  ...LeaveRequestPaths,
  ...PassportRequestPaths,
  ...SalaryCertificatePaths,
  ...OverseasMissionPaths,
  ...ResumptionRequestsPaths,
  ...AttendanceRequestPaths,
  ...ResignationRequestsPaths,
};
